import ApiService from '@api/api-service';

let VCA = VCA || {};

VCA.CareClubPetPage = (function ($) {

    let ui = {};

    function cacheUI() {
        ui.$PaymentMethodsUpdateButton = $('#PaymentMethodsUpdateBtn');
        ui.$PaymentMethodsCancelButton = $('#PaymentMethodsCancelBtn');
        ui.$PaymentMethodsIframe = $('.petpage-care-club__iframe-container');
        ui.$PaymentMethodsUserCardInfoContainer = $('.petpage-care-club__pm-content');
        ui.$RenewalStatus = $('#CareClubRenewalStatus');
        ui.$RenewalApplyBtn = $('#CareClubApplyBtn');
        ui.$MainContentWrapper = $('.petpage-care-club__mr-wrapper');
        ui.$SuccessMessage = $('.petpage-care-club__mr-success-msg');
        ui.$RenewalErrorMessage = $('.petpage-care-club__mr-error-msg');
        ui.$PatientId = $('#CareClubApplyBtn').data('patientid');
        ui.$isRenewalOn = false;
    }

    function bindEvents() {
        ui.$PaymentMethodsUpdateButton.on('click', displayIframe);
        ui.$PaymentMethodsCancelButton.on('click', hideIframe);
        ui.$RenewalStatus.on('change', toggleApplyBtn);
        ui.$RenewalApplyBtn.on('click', () => updateRenewalStatus(ui.$isRenewalOn));
    }

    function displayIframe() {
        ui.$PaymentMethodsUpdateButton.addClass('active');
        ui.$PaymentMethodsIframe.show();
        ui.$PaymentMethodsUserCardInfoContainer.hide();
    }

    function hideIframe() {
        ui.$PaymentMethodsUpdateButton.removeClass('active');
        ui.$PaymentMethodsIframe.hide();
        ui.$PaymentMethodsUserCardInfoContainer.show();
    }

    function renewalStatusOnLoad() {
        let renewalStatus = ui.$RenewalStatus.data('value');

        if (renewalStatus) {
            ui.$RenewalStatus.prop('checked', true);
        } else {
            ui.$RenewalStatus.prop('checked', false);
        }
    }

    function toggleApplyBtn() {
        ui.$isRenewalOn = ui.$RenewalStatus.is(':checked');
        ui.$RenewalApplyBtn.prop('disabled', false);
    }
    
    function resetSuccessErrorMsgs() {
        ui.$SuccessMessage.hide();
        ui.$RenewalErrorMessage.hide();
    }

    async function updateRenewalStatus(renewalStatus) {
        ui.$SuccessMessage.hide();

        const searchParams = params => Object.keys(params).map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');

        let payload = {
            'PatientId': ui.$PatientId,
            'RenewalStatus': renewalStatus
        }
            
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }
        
        const url = '/api/careclub/renew';
        let api = new ApiService(url);
        const { success, data, error } = await api.post(searchParams(payload), axiosConfig);

        resetSuccessErrorMsgs();

        if (success) {
            ui.$SuccessMessage.show();
        } else {
            ui.$MainContentWrapper.hide();
            ui.$RenewalErrorMessage.show();
        }
    }

    function init() {
        if ($('.petpage-care-club').length <= 0) {
            return;
        }

        cacheUI();
        bindEvents();
        renewalStatusOnLoad();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    $(document).ready(function() {
        VCA.CareClubPetPage.init();
    });
});
